<div class="h-screen w-screen overflow-y-scroll">
  <lm-sidenav [items]="navItems"></lm-sidenav>
  <div class="ml-[100px]">
    <router-outlet></router-outlet>
  </div>
</div>
